<!-- template for the modal component -->
<template type="x/template">
  <transition name="modal" id="contact-info-dialog">
    <div class="modal-mask" v-show="show">
      <div class="modal-container" @click.stop>
        <div class="modal-header">
          <h3>{{ $t('bulk_actions.parcel_culture_change') }}</h3>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="form col-lg-5">
              <label class="control-label">{{$t("common.culture")}}</label>
              <b-form-select
                  v-model="culture_uuid"
                  class="form-control"
                  @change="onCultureChanged"
                  :class="{ 'field-error' : $v.culture_uuid.$error }"
                  :options="culture_list"></b-form-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 fw-bold">
              {{ $t('works.parcels.selected_parcels', { count: modalData.items?.length })}}
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 text-danger">
              {{ error }}
            </div>
          </div>
        </div>
        <div class="modal-footer col-lg-12">
          <div class="form-group row justify-content-end">
            <div class="col-lg-6">
              <button class="btn btn-outline-success" @click="OK()">{{$t("common.change")}}</button>
            </div>
            <div class="col-lg-6">
              <button class="modal-default-button btn btn-outline-secondary ml-3" @click="close()">{{$t("common.close")}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import {buildDropdownOptions} from "@/helpers/common";
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'ParcelCultureChangeDialog',
  props: ['show', 'data'],
  data: function () {
    return {
      modalData: this.data,
      culture_uuid: null,
      error: '',
    };
  },
  computed: {
    ...mapGetters({
        cultures: "works-cultures/cultures",
    }),
    culture_list() {
      return buildDropdownOptions(this.cultures, {
        value: 'uuid',
        text: 'name',
      }, {
        value: null,
        text: this.$t('works.parcels.select_culture_to_apply'),
      });
    }
  },
  methods: {
    ...mapActions({
        getCultures: "works-cultures/getCultures",
    }),
    close: function () {
      this.$emit('close');
    },
    OK () {
      this.$v.culture_uuid.$touch();
      if(!this.$v.culture_uuid.$invalid) {
        this.modalData.culture_uuid = this.culture_uuid;
        this.modalData.culture_name = this.cultures.find(c => c.uuid === this.culture_uuid).name;
        this.$emit('onParcelCultureApplied', this.modalData);
        this.close();
      }
    },
    setErrorMessage(msg) {
      this.error = msg;
    },
    onCultureChanged(value) {
      this.$emit('onParcelCultureChanged', value);
    }
  },
  mounted() {
      this.getCultures({ enablePagination: 0, limit: 9999 });
  },
  watch: {
    data: function(newVal) {
      this.modalData = newVal;
    },
    show: function(newVal) {
      this.setErrorMessage("");
    }
  },
  validations() {
    return {
      culture_uuid: {
        required,
      },
    }
  },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
</style>
